// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navigation link styles */
.nav-link {
  color: #222;
  text-decoration: none;
  padding: 8px 18px;
  font-weight: 500;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
}

.nav-link:hover {
  background: #e3e3e3;
  color: #007bff;
}

.active-link {
  background: #007bff;
  color: #fff !important;
  border-radius: 4px;
}
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: cornsilk;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* App.css */
.image-container {
  text-align: left; /* You can use 'left', 'right', or 'center' */
}

.image {
  width: 300px;
  height: 300px;
}

footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 20px;
  position: relative;
  bottom: 0;
  width: 100%;
}

footer a {
  color: white;
  text-decoration: none;
}

footer a:hover {
  text-decoration: underline;
}


.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  padding: 10px;
  background-color: #333;
  color: white;
  border: none;
  cursor: pointer;
}

.dropdown-button:hover {
  background-color: #555;
}

/* src/App.css */

.navbar {
  background-color: #333;
  padding: 10px;
}

.nav-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
}

.nav-list li {
  margin-right: 20px;
}

.nav-list li a {
  color: white;
  text-decoration: none;
  font-size: 18px;
}

.nav-list li a:hover {
  text-decoration: underline;
}

/* Styling for the dropdown */
.dropdown {
  position: relative;
}

.dropdown-link {
  color: white;
  text-decoration: none;
  font-size: 18px;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #333;
  border: 1px solid #ddd;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu li {
  padding: 10px;
}

.dropdown-menu li a {
  color: white;
  text-decoration: none;
}

.dropdown-menu li a:hover {
  background-color: #555;
}

/* Show the dropdown menu when the item is hovered or active */
.dropdown:hover .dropdown-menu {
  display: block;
}

.subject-dropdown {
    width: 100%;
    padding: 8px 12px;
    margin: 8px 0;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
}

.subject-dropdown:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.subject-dropdown option {
    padding: 8px;
}
/*  For Hiper links */
.links-container {
  display: flex;
  gap: 12px;
  padding: 2rem;
  flex-wrap: wrap;
  padding: 16px 0; /* keep some vertical padding around the whole block */
  justify-content: center;
  background-color: #f5f5f5;
}

.links-box {
  flex: 1 1;
  min-width: 500;
  max-width: 650px;
   padding: 12px 14px; /* reduce box padding */
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.links-box h3 {
  color: #050505;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  border-bottom: 2px solid #979899;
  padding-bottom: 0.5rem;
}

.links-box ul {
  margin: 0;
  padding-left: 16px; /* keep small indent for bullets */
  list-style-position: inside;
}

.links-box li {
  margin: 0px 0; /* smaller gap between items */
  line-height: 1.35; /* denser lines */

}

.links-box a {
  color: #1d2020;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 6px 0; /* remove extra vertical padding */
  display: inline-block;
}

.links-box a:hover {
  color: #01070c;
  background-color: #dedcdc;
}

.address-black {
  color: #111;
  font-weight: 500;
}



/*    responsive   web  */
@media (max-width: 768px) {

  /* Stack flex items vertically, reduce padding/margins, smaller fonts */
  .container {
    flex-direction: column;
    padding: 16px;
  }

  h1 {
    font-size: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 480px) {

  /* Further reductions for phones */
  .nav-bar {
    font-size: 20px;
    padding: 4px 8px;
  }

  .intro-box {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,YAAY;AACZ;EACE,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;;AAEhB;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,cAAc;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;AACA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;EACf,eAAe,EAAE,sDAAsD;EACvE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;GACf,kBAAkB,EAAE,uBAAuB;EAC5C,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,kCAAkC;EACtD,2BAA2B;AAC7B;;AAEA;EACE,aAAa,EAAE,8BAA8B;EAC7C,iBAAiB,EAAE,iBAAiB;;AAEtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc,EAAE,kCAAkC;EAClD,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;;;AAIA,yBAAyB;AACzB;;EAEE,uEAAuE;EACvE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;EAEE,kCAAkC;EAClC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Navigation link styles */\n.nav-link {\n  color: #222;\n  text-decoration: none;\n  padding: 8px 18px;\n  font-weight: 500;\n  border-radius: 4px;\n  transition: background 0.2s, color 0.2s;\n}\n\n.nav-link:hover {\n  background: #e3e3e3;\n  color: #007bff;\n}\n\n.active-link {\n  background: #007bff;\n  color: #fff !important;\n  border-radius: 4px;\n}\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: cornsilk;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* App.css */\n.image-container {\n  text-align: left; /* You can use 'left', 'right', or 'center' */\n}\n\n.image {\n  width: 300px;\n  height: 300px;\n}\n\nfooter {\n  background-color: #333;\n  color: white;\n  text-align: center;\n  padding: 20px;\n  position: relative;\n  bottom: 0;\n  width: 100%;\n}\n\nfooter a {\n  color: white;\n  text-decoration: none;\n}\n\nfooter a:hover {\n  text-decoration: underline;\n}\n\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-button {\n  padding: 10px;\n  background-color: #333;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.dropdown-button:hover {\n  background-color: #555;\n}\n\n/* src/App.css */\n\n.navbar {\n  background-color: #333;\n  padding: 10px;\n}\n\n.nav-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n}\n\n.nav-list li {\n  margin-right: 20px;\n}\n\n.nav-list li a {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n.nav-list li a:hover {\n  text-decoration: underline;\n}\n\n/* Styling for the dropdown */\n.dropdown {\n  position: relative;\n}\n\n.dropdown-link {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n.dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: #333;\n  border: 1px solid #ddd;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dropdown-menu li {\n  padding: 10px;\n}\n\n.dropdown-menu li a {\n  color: white;\n  text-decoration: none;\n}\n\n.dropdown-menu li a:hover {\n  background-color: #555;\n}\n\n/* Show the dropdown menu when the item is hovered or active */\n.dropdown:hover .dropdown-menu {\n  display: block;\n}\n\n.subject-dropdown {\n    width: 100%;\n    padding: 8px 12px;\n    margin: 8px 0;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n    background-color: white;\n}\n\n.subject-dropdown:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.subject-dropdown option {\n    padding: 8px;\n}\n/*  For Hiper links */\n.links-container {\n  display: flex;\n  gap: 12px;\n  padding: 2rem;\n  flex-wrap: wrap;\n  padding: 16px 0; /* keep some vertical padding around the whole block */\n  justify-content: center;\n  background-color: #f5f5f5;\n}\n\n.links-box {\n  flex: 1;\n  min-width: 500;\n  max-width: 650px;\n   padding: 12px 14px; /* reduce box padding */\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.links-box h3 {\n  color: #050505;\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n  border-bottom: 2px solid #979899;\n  padding-bottom: 0.5rem;\n}\n\n.links-box ul {\n  margin: 0;\n  padding-left: 16px; /* keep small indent for bullets */\n  list-style-position: inside;\n}\n\n.links-box li {\n  margin: 0px 0; /* smaller gap between items */\n  line-height: 1.35; /* denser lines */\n\n}\n\n.links-box a {\n  color: #1d2020;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  padding: 6px 0; /* remove extra vertical padding */\n  display: inline-block;\n}\n\n.links-box a:hover {\n  color: #01070c;\n  background-color: #dedcdc;\n}\n\n.address-black {\n  color: #111;\n  font-weight: 500;\n}\n\n\n\n/*    responsive   web  */\n@media (max-width: 768px) {\n\n  /* Stack flex items vertically, reduce padding/margins, smaller fonts */\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  h1 {\n    font-size: 1.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Further reductions for phones */\n  .nav-bar {\n    font-size: 20px;\n    padding: 4px 8px;\n  }\n\n  .intro-box {\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
